import { apiCustomer } from "@/api"
import { LoyaltyPoints, LoyaltyProgram, LoyaltyTransaction } from "@/types/loyalty"

/**
 * Fetches the customer's loyalty points balance and the merchant's loyalty
 * program in parallel. Errors propagate — callers decide the fallback
 * (loyalty is optional in checkout).
 */
export async function fetchLoyalty(
  merchantId: string,
): Promise<{ points: LoyaltyPoints; program: LoyaltyProgram }> {
  const pathLoyalty = `/loyalties/by-merchant/${merchantId}`
  const [{ data: points }, { data: program }] = await Promise.all([
    apiCustomer.get<LoyaltyPoints>(`${pathLoyalty}/points`),
    apiCustomer.get<LoyaltyProgram>(`${pathLoyalty}/program`),
  ])
  return { points, program }
}

/**
 * Fetches the customer's loyalty transactions for the merchant.
 * Returned in API order — callers keep their own sorting.
 */
export async function fetchLoyaltyTransactions(
  merchantId: string,
): Promise<LoyaltyTransaction[]> {
  const { data } = await apiCustomer.get<LoyaltyTransaction[]>(
    `/loyalties/by-merchant/${merchantId}/transactions`,
  )
  return data
}
